import type { FC } from "react";
import { useTranslation } from "react-i18next";
import SystemButton from "../../UIToolkit/SystemButton/SystemButton";

type Props = {
	onReview: () => void;
};

/** Open the real pickup review before approving or declining anyone. */
export const OutreachApprovalWaitingActions: FC<Props> = ({ onReview }) => {
	const { t } = useTranslation();
	return (
		<SystemButton data-testid="outreach-approval-review" buttonVariant="primary" noFullWidthMobile onClick={onReview}>
			{t("request.outreach.approval.review")}
		</SystemButton>
	);
};
